import { isEqual } from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { createAction } from 'redux-actions';

import './AutomaticDefer.scss';

import {
  AUTOMATIC_TRANSACTION_DEFER,
  AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL,
  AUTOMATIC_TRANSACTION_DEFER_DELETE_SUCCESS,
} from '../../../redux/modules/modals/modals.module';
import Button from '../../Shared/Button/Button';
import Dropdown from '../../Shared/Dropdown/Dropdown';
import If from '../../Shared/If/If';
import { DEFER_RECURRING_TRANSACTION_FULFILLED } from '../../../redux/modules/automaticInvestments/automaticInvestments.module';
import { getHasCollegeOnly } from '../../../redux/modules/productTypes/productType.selectors';
import { getCartLookup } from '../../../redux/modules/shoppingCart/shoppingCart.selectors';
import { moduleActions } from '../../../redux/modules';
import {
  AUTOMATIC_UPDATE_RELOAD,
  PRODUCT_TYPE_LABEL_MAP,
} from '../../../settings/settings';
import { getMonthName } from '../../../utils/dates/date-utility';
import { scrollElementIntoFullView } from '../../../utils/dom-utils';
import {
  agreementTypeToProperCase,
  getMonthYear,
  isProductType529,
  optionSorter,
} from '../../../utils/funds/funds-utility';
import { isCustomerWebViewEnabled } from '../../../redux/modules/authentication/authentication.module.selectors';

class AutomaticDefer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMonth1:
        props.fund.deferMonths.length > 0
          ? { value: props.fund.deferMonths[0] }
          : null,
      selectedMonth2:
        props.fund.deferMonths.length > 1
          ? { value: props.fund.deferMonths[1] }
          : null,
    };
  }

  componentDidMount() {
    const { dispatchPageLoad, fund } = this.props;
    const modalName = isProductType529(fund.productType)
      ? 'College|Contribute|SkipModal'
      : 'Buy|SkipModal';
    dispatchPageLoad(modalName);
  }

  makeOptions(num) {
    const { fund } = this.props;
    const { selectedMonth1, selectedMonth2 } = this.state;

    return fund.transferMonths
      .map((month) => {
        const year = getMonthYear(month, fund);
        return {
          value: month,
          label: `${getMonthName(getMonthName(month).toUpperCase())} ${year}`,
          year: year,
        };
      })
      .sort(optionSorter)
      .filter((month) => {
        return (
          month.value !==
          (num === 2
            ? selectedMonth1
              ? selectedMonth1.value
              : -1
            : selectedMonth2
            ? selectedMonth2.value
            : -1)
        );
      });
  }

  doDefer(fund, deferMonths) {
    const {
      actions: {
        updateSystematicTransaction,
        getSystematicPurchases,
        openModal,
        setAutoUpdateLoading,
      },
      dispatch,
      closeModal,
    } = this.props;
    closeModal(AUTOMATIC_TRANSACTION_DEFER, { fund: fund });
    scrollElementIntoFullView('automatic-landing-page-container');
    Promise.all([
      dispatch(
        updateSystematicTransaction(
          fund,
          deferMonths,
          'MODIFY',
          'PURCHASE',
          null,
          'SKIP'
        )
      ),
      setAutoUpdateLoading(),
    ]).then(
      (res) => {
        res.map((response) => {
          const {
            action: { type },
          } = response;
          if (type === DEFER_RECURRING_TRANSACTION_FULFILLED) {
            const {
              value: {
                body: { transactions },
              },
            } = response;
            const allFailed = transactions.every(
              (transaction) => !transaction.success
            );
            if (allFailed) {
              openModal(AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL, {
                fund: fund,
                type: 'Buy',
                actionType: 'skip',
              });
              dispatch(
                createAction(`${AUTOMATIC_UPDATE_RELOAD}_FULFILLED`)(true)
              );
            } else {
              Promise.all([getSystematicPurchases()]).then(
                () => {
                  dispatch(
                    createAction(`${AUTOMATIC_UPDATE_RELOAD}_FULFILLED`)(true)
                  );
                  openModal(AUTOMATIC_TRANSACTION_DEFER_DELETE_SUCCESS, {
                    fund: fund,
                    type: 'Buy',
                    actionType: 'skip',
                  });
                },
                () => {
                  const action = createAction(
                    `${AUTOMATIC_UPDATE_RELOAD}_REJECTED`
                  )(true);
                  dispatch(action);
                }
              );
            }
          }
          return response;
        });
      },
      () => {
        const action = createAction(`${AUTOMATIC_UPDATE_RELOAD}_FULFILLED`)(
          true
        );
        dispatch(action);
        openModal(AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL, { fund: fund });
      }
    );
  }

  onChange1 = (selectedOption) => {
    this.setState({ selectedMonth1: selectedOption });
  };

  onChange2 = (selectedOption) => {
    this.setState({ selectedMonth2: selectedOption });
  };

  noChange(deferMonths) {
    const { fund } = this.props;
    return isEqual(fund.deferMonths, deferMonths);
  }

  render() {
    const { closeModal, customerWebViewEnabled, fund, getHasCollegeOnly } =
      this.props;
    const { selectedMonth1, selectedMonth2 } = this.state;
    const oldDefer = fund.deferMonths ? fund.deferMonths : [];
    const transferMonths = fund.transferMonths ? fund.transferMonths : [];
    const oldDeferMonth1 = oldDefer.length > 0 ? oldDefer[0] : -1;
    const oldDeferMonth2 = oldDefer.length > 1 ? oldDefer[1] : -1;

    const getOldDeferMonth = (oldDeferMonth) => {
      return oldDeferMonth >= 0
        ? {
            value: oldDeferMonth,
            label: `${getMonthName(
              getMonthName(oldDeferMonth).toUpperCase()
            )} ${getMonthYear(oldDeferMonth, fund)}`,
          }
        : false;
    };

    const deferMonths = [];
    if (selectedMonth1) {
      deferMonths.push(selectedMonth1.value);
    }
    if (selectedMonth2) {
      deferMonths.push(selectedMonth2.value);
    }
    return (
      <div className="automatic-defer-container">
        <div className="automatic-defer-info-container">
          <div className="automatic-defer-title">
            Skip {transferMonths.length > 1 ? 'Month(s)' : 'a Month'} of Your
            Automatic {getHasCollegeOnly ? 'Monthly Contribution' : 'Buy'}
          </div>
          <div className="automatic-defer-sub-title">
            Skip your{' '}
            {getHasCollegeOnly
              ? 'Automatic Monthly Contribution'
              : 'automatic buy'}{' '}
            for{' '}
            <span className="automatic-defer-emphasis">
              {fund.fundName} -{' '}
              {isProductType529(fund.productType)
                ? PRODUCT_TYPE_LABEL_MAP[fund.productType]
                : agreementTypeToProperCase(fund.agreementType)}
            </span>
            <span className="automatic-defer-fund-details blocked_data">
              {' '}
              ({fund.agreementNumber}, {fund.formattedEntityNames}){' '}
            </span>
          </div>
          <div className="automatic-defer-dropdown-detail-text">
            <div className="automatic-defer-dropdown-title">
              Which month{transferMonths.length > 1 ? '(s)' : ''} would you like
              to skip?
            </div>
          </div>
          <div className="automatic-defer-dropdown-wrapper">
            <Dropdown
              options={this.makeOptions(1)}
              onChange={this.onChange1}
              preSelected={getOldDeferMonth(oldDeferMonth1)}
              placeholder={'Select a Month'}
            />
          </div>
          <If test={transferMonths.length > 1}>
            <div className="automatic-defer-dropdown-wrapper">
              <Dropdown
                options={this.makeOptions(2)}
                onChange={this.onChange2}
                placeholder={'Select a Month'}
                preSelected={getOldDeferMonth(oldDeferMonth2)}
              />
            </div>
          </If>
          <div className="automatic-defer-disclaimer">
            <span className="automatic-defer-emphasis">Please Note: </span>
            This may take up to three business days to process. If your next{' '}
            {getHasCollegeOnly ? 'contribution' : 'buy'} is scheduled in the
            next three business days, you may not be able to skip this{' '}
            {getHasCollegeOnly ? 'contribution' : 'transaction'}.
          </div>
        </div>
        <div className="automatic-defer-buttons-container">
          <Button
            className="automatic-defer-save-btn"
            buttonType="primary"
            disabled={
              deferMonths.length <= 0 ||
              this.noChange(deferMonths) ||
              customerWebViewEnabled
            }
            id="defer-btn"
            stylename="automatic-defer-save-btn"
            onClick={() => this.doDefer(fund, deferMonths)}
          >
            Save
          </Button>
          <a
            className="automatic-defer-cancel-btn"
            id="cancel-defer-btn"
            onClick={() => closeModal(AUTOMATIC_TRANSACTION_DEFER)}
          >
            Cancel
          </a>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...moduleActions }, dispatch),
  dispatch,
});

const mapStateToProps = (state) => {
  return {
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    fundDates: getCartLookup(state),
    getHasCollegeOnly: getHasCollegeOnly(state),
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  AutomaticDefer
);
